import { GameMode } from "./GameMode.js";
import { BotType } from "./BotType.js";
import type { Ruleset } from "./Ruleset.js";
import type { GameSettings } from "../../royalur/model/GameSettings.js";


/**
 * The settings of a game that are chosen during setup.
 */
export abstract class LobbySettings {
    private readonly available: boolean;
    private readonly lobbyID: string | null;

    protected constructor(available: boolean, lobbyID: string | null) {
        this.available = available;
        this.lobbyID = lobbyID;
    }

    isAvailable(): boolean {
        return this.available;
    }

    getLobbyID(): string | null {
        return this.lobbyID;
    }

    abstract getMode(): GameMode;

    abstract getRuleset(): Ruleset;

    abstract getGameSettings(): GameSettings;

    abstract getCustomGameSettings(): GameSettings;

    abstract getBotType(): BotType;

    isRemote(): boolean {
        const gameMode = this.getMode();
        if (gameMode.isRemote())
            return true;
        if (gameMode === GameMode.COMPUTER && this.getBotType().isOnline())
            return true;
        return false;
    }

    requiresAccount(): boolean {
        const ruleset = this.getRuleset();
        if (!ruleset.hasSettings())
            return true;

        const mode = this.getMode();
        const difficulty = this.getBotType();
        return mode === GameMode.COMPUTER
            && (difficulty === BotType.HARD || difficulty === BotType.PANDA);
    }

    abstract toJSON(): string;

    abstract equals(other: LobbySettings): boolean;
}
